import { type FormEvent, useRef, useState } from 'react';
import { notifications } from '@mantine/notifications';
import { ShiftAuthRequestError, shiftAuthService } from '../../services/auth/shift-auth.service';

export function useChangePasswordPageController() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const passwordWriteInFlightRef = useRef(false);

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (passwordWriteInFlightRef.current) {
      return;
    }

    if (newPassword !== confirmPassword) {
      notifications.show({ color: 'red', title: 'שגיאה', message: 'אימות הסיסמה אינו תואם.' });
      return;
    }

    passwordWriteInFlightRef.current = true;
    setIsLoading(true);
    try {
      await shiftAuthService.changePassword(currentPassword, newPassword, confirmPassword);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      notifications.show({ color: 'green', message: 'הסיסמה עודכנה בהצלחה.' });
    } catch (requestError: unknown) {
      if (requestError instanceof ShiftAuthRequestError) {
        notifications.show({
          color: 'red',
          title: 'שגיאה',
          message: requestError.message || 'עדכון הסיסמה נכשל.',
        });
      } else {
        notifications.show({ color: 'red', title: 'שגיאה', message: 'עדכון הסיסמה נכשל.' });
      }
    } finally {
      passwordWriteInFlightRef.current = false;
      setIsLoading(false);
    }
  };

  return {
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    isLoading,
    onSubmit,
  };
}
